import * as React from "react";
import styled from "styled-components";

interface RegistrationCtrlProps {}

function RegistrationCtrl(props: RegistrationCtrlProps) {
  return <h1>REGISTRATION</h1>;
}
export const Registration = styled(RegistrationCtrl)((props) => ({}));
